import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { FEATURE_FLAG_API_URL } from '../constants';

export enum Feature {
  // It is a feature used in the webapp but not in the builder, although it may still be exposed in the builder.
  // ASK_AVO = 'ASK_AVO',
  // AI_SCRIBE = 'AI_SCRIBE',
  // AI_SCRIBE_OPTUM = 'AI_SCRIBE_OPTUM',
  // URL_ALGO = 'URL_ALGO',
  TIPTAP_CONVERTING = 'TIPTAP_CONVERTING',
  PROMPT_DEBUGGING = 'PROMPT_DEBUGGING',
  // TODO: Remove this when all features are released
  TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE = 'TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE',
}

const DEFAULT_FEATURE_FLAG = {
  [Feature.TIPTAP_CONVERTING]: false,
  [Feature.PROMPT_DEBUGGING]: false,
  [Feature.TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE]: false,
};

type FeatureFlagGetResponse = {
  [key in Feature]: boolean;
};

export function useFeatureFlags(
  option?: UseQueryOptions<FeatureFlagGetResponse>
): UseQueryResult<FeatureFlagGetResponse> {
  return useQuery<FeatureFlagGetResponse>({
    queryKey: ['featureFlags'],
    queryFn: () =>
      axios.get<FeatureFlagGetResponse>(FEATURE_FLAG_API_URL).then((response) => response.data),
    placeholderData: DEFAULT_FEATURE_FLAG,
    ...option,
  });
}
